<template>
  <div class="reportCard">
    <div class="title-class">{{ reviceData.title }}</div>
    <div class="content-class">{{ reviceData.content }}</div>

    <div v-if="reviceData.title.includes('SDNN')" class="progress-class">
      <van-progress 
        :percentage="reviceData.lineValue"
        :show-pivot="false"
        stroke-width="25"
        color="#FF0202"
      />
    </div>

    <div
      v-else
      class="row-class"
      :style="{
        background: `linear-gradient(to right, ${reviceData.barColor[0]}, ${reviceData.barColor[1]} , ${reviceData.barColor[2]})`,
      }"
    >
      <div
        class="line-class"
        :style="{ marginLeft: `${reviceData.lineValue}%` }"
      ></div>
    </div>

    <div class="prompt-class">
      <span :style="{ color: reviceData.barColor[0] }">{{
        reviceData.promptStatus[0]
      }}</span>
      <span :style="{ color: reviceData.barColor[1] }">{{
        reviceData.promptStatus[1]
      }}</span>
      <span :style="{ color: reviceData.barColor[2] }">{{
        reviceData.promptStatus[2]
      }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "ReportCard",
  props: {
    reviceData: {
      type: Object,
    },
  },
};
</script>

<style lang="less" scoped>
.reportCard {
  width: 95%;
  margin: 10px;
  border: 1px solid #f3f3f3;
  box-shadow: 10px 5px 10px #f3f3f3;
  border-radius: 20px;
}

.title-class {
  margin: 15px 0 0 15px;
  font-size: 18px;
  font-weight: 600;
}

.content-class {
  margin: 5px 15px;
  word-wrap: break-word;
  font-family: PingFangSC-regular;
  font-size: 16px;
}

.row-class {
  margin: 15px 0 0 10px;
  position: relative;
  border-radius: 40px;
  width: 95%;
  height: 25px;
  background: linear-gradient(to left, green, yellow, red);
}

.line-class {
  border: 2px solid #a8a8b0;
  background-color: white;
  position: absolute;
  margin-top: -5px;
  width: 3px;
  height: 35px;
  border-radius: 10px;
}

.prompt-class {
  margin: 15px 15px;
  display: flex;
  justify-content: space-between;
  font-size: 16px;
}

.progress-class {
  width: 95%;
  margin: 10px 0px 0 10px;
  font-size: 12px;
  border-radius:20px;
}

.van-progress{
  border-radius:20px;
}

.van-progress__portion {
  border-radius:20px;
}
</style>